export default __webpack_public_path__ + "static/media/about.41d84077.jpg";